import { styled } from "styled-components";
import { AnalyticsContainerIntro } from "../../Pages/DashboardStyle";

export const BarAnalyticsDisplayContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 90%;
    height: 65%;
    justify-content: center;
    align-items: center;
    padding: 10px;
    overflow: auto;
    border-radius: 10px;
    animation: ${AnalyticsContainerIntro} ${props=>props.theme.animationTime.long}s;
    @media screen and (max-width: ${props=>props.theme.breakpoint}px){
        display: none;
    }
`;